import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AdminMeStoreService } from '@core/domains/adminMe/adminMe-store.service';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs';


@Injectable()
export class GetDefaultRouteService  {

  constructor(
    private router: Router,
    private adminStore: AdminMeStoreService
  ) { }

  canActivate(): Observable<UrlTree> {
    const me = this.adminStore.adminMe ?? this.adminStore.initAdmin();
    return of(this.router.parseUrl(me.defaultModulePath));
  }
}
